<template>
    <v-footer v-if="usuarioLogado" class="footer-gradient" app elevation="8">
        <div class="d-flex align-center justify-space-between w-100 px-4 py-2">
            <div class="d-flex align-center">
                <p class="mb-0 footer-text">COPYRIGHT © {{ new Date().getFullYear() }} - AICHECKIN INTELITE</p>
            </div>
            
            <div class="d-flex align-center">
                <v-btn icon class="mx-1 social-btn" href="https://www.instagram.com/intelite_tecnologia/" target="_blank">
                    <img src="../assets/instagram.png" width="20" height="20" alt="Instagram">
                </v-btn>
                <v-btn icon class="mx-1 social-btn">
                    <v-icon>mdi-facebook</v-icon>
                </v-btn>
                <v-btn icon class="mx-1 social-btn">
                    <v-icon>mdi-linkedin</v-icon>
                </v-btn>
            </div>
        </div>
    </v-footer>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data () {
    return { 
    }
},
mounted: function () { 
        if(sessionStorage.getItem('accToken') != null)                    
        this.$store.dispatch('Logar', this.token)
    },
computed: mapState({
        usuarioLogado: state => state.isMenuVisible,
        username: state => state.UserName
    }),

}
</script>

<style scoped>
.footer-gradient {
    background: linear-gradient(to right, #6a11cb, #2575fc);
    color: white;
    box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 98;
}

.footer-text {
    font-size: 0.78rem;
    font-weight: 500;
    letter-spacing: 1px;
    opacity: 0.9;
    color: white;
}

.social-btn {
    transition: all 0.3s ease;
    margin: 0 5px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
}

.social-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.v-icon {
    color: white !important;
}
</style>
